/* Editorial scroll reveal — fades each content section up as it enters
   the viewport, giving the whole store the same motion as the hero.
   Safe by design: if JS or IntersectionObserver is unavailable, nothing
   is hidden. Respects reduced-motion and the Shopify theme editor. */
(function () {
  var docEl = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  docEl.classList.add('editorial-on');

  var main = document.querySelector('main') || document.body;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ed-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

  function bind() {
    var sections = main.querySelectorAll('.shopify-section');
    sections.forEach(function (sec, i) {
      // Skip the first section (hero already animates itself) and any
      // already-bound section.
      if (i === 0 || sec.classList.contains('ed-reveal')) return;
      sec.classList.add('ed-reveal');
      io.observe(sec);
    });
  }

  bind();

  // In the theme editor, reveal immediately when a section is selected/loaded.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      e.target.classList.add('ed-reveal', 'ed-in');
    });
  }
})();
